export default "__VITE_ASSET__ALhEU9FR__"